export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8368.05763f09.jpg";